<template>
    <split-pane  :min-percent='5' :default-percent='14' split="vertical" style="background:white; height:100%">
        <template slot="paneL"  >
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"></el-input>
            <el-tree :data="tyData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        default-expand-all
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto', 'margin-top':'3px'}"
                        highlight-current
                        ref="eltree"
                        :filter-node-method="filterNode"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                        
                        <span   style="font-size:14px; color:#409efe"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:18px;margin-right:4px;"></i>{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#E6A23C;font-size:10px;margin-right:4px;"></i>{{ node.label}} </span>
                    </span>
                </template>
            </el-tree>         
        </template>
        <template slot="paneR">
            <split-pane  :min-percent='5' :default-percent='70' split="vertical" style="background:white; height:100%">
                <template slot="paneL"  >
                    <!-- <el-tabs v-model="activeTab" style="background:#fff;margin-bottom:10px;">
                        <el-tab-pane name="tab01"> 
                            <span slot="label"><i class="iconfont icon-shengchanchejian" style="font-size:20px"></i> 生产工艺  </span>
                        </el-tab-pane>
                        <el-tab-pane name="tab02">
                            <span slot="label"><i class="iconfont icon-dengdaishouhuo" style="font-size:20px"></i> 物流工艺  </span>
                        </el-tab-pane>
                        <el-tab-pane name="tab03"> 
                            <span slot="label"><i class="iconfont icon-meiyuan" style="font-size:20px"></i> 付款工艺  </span>
                        </el-tab-pane>
                    </el-tabs> -->
                    <div style="display:flex;line-height:25px ;  "> 
                        <div  class="oneMenu" @click="itemClick('one')">
                            <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                                <i class="iconfont icon-shengchanchejian" style="margin-left:4px;margin-right:5px"></i>生产工艺 </div> 
                        </div>
                       
                    </div>
                    <span v-show="actitem=='one'"> 
                        <div :style="{'margin-top':'2px','overflow':'auto','background':'white'}" class="wrap" >
                            <el-table  :data="dtlData" 
                                    border                            
                                    disabled-hover 
                                    style="overflow:auto;margin-top:1px;"
                                    size="small"
                                    :cell-style="{'padding-top':'3px','padding-bottom':'3px','margin-left':'-4px','color':'black'}"
                                    :header-cell-style="{'padding':'4px','background':'#389','color':'white'}"
                                    :height="dtlHeight"              
                                    ref="reftree" 
                                    row-key="refprcseq"      
                          
                                    default-expand-all
                                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
                                    class="custom-table-border"
                               
                                    highlight-current-row>
                                <el-table-column label="序号" type="index" width="50" ></el-table-column>
                                <el-table-column label="工序名称" prop="label" :min-width="170" :show-overflow-tooltip="true" align="left"></el-table-column>
                                <el-table-column  v-for="(item,index ) in treeCol.filter(item=>item.thide=='N'&& item.key!=='label' )" :key="index"
                                    :prop="item.key"
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                           
                                    :min-width="item.width">
                                    <template slot-scope="scope">                
                                        <el-checkbox v-if="item.key=='stfg'" style="height:10px" @change="setType(scope.row )" true-label="Y" false-label="N" v-model="scope.row[item.key]"> </el-checkbox>                        
                                        <span v-else-if="item.key=='outflag'">
                                            <el-tag   size="mini" type="success" effect="dark" v-if="scope.row['outflag']=='Y'">是</el-tag>
                                            <el-tag   size="mini" type="info" effect="dark" v-else  >否</el-tag>
                                        </span>
                                        <span v-else-if="item.key=='jobno'">
                                            <el-link :underline="false" :disabled="v_stfg=='Y'" @click="jobLink(scope.row)"><span style="border-bottom:1px solid blue;font-size:12px">{{scope.row.jobno}}</span></el-link>
                                        </span>
                                        <div v-else v-text="scope.row[item.key]" style="float:left;text-overflow:ellipsis;overflow: hidden;white-space:nowrap;width:100%;text-align:left"> </div>
                                    </template>
                                </el-table-column>            
                            </el-table> 
                        </div>     
                    </span>
                </template>
                <template slot="paneR"> 
                    <div class="one-div">
                        <span class="oneRow"> 
                            工序明细
                            <el-checkbox v-model="v_all" @change="chkSel" true-label="Y" false-label="N" style="margin-left:15px;font-size:12px">全选</el-checkbox>
                            <el-button :disabled="editBool " @click="addJob" type="danger" plain size="mini" style="height:26px;margin-top:1px;margin-left:20px;border:1px solid #f00">
                                <i class="iconfont icon-piliangdaoru" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>添加到工艺
                            </el-button>
                        </span>
                    </div>
                    <el-table  :data="jobData" 
                        border                            
                        size="small"
                        class="custom-table-border"
                        v-loading="loading"
                        header-cell-class-name="clearPadding"
                        :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        :height="subHeight"    
                        ref="refjob"
                        highlight-current-row
                        style="overflow:auto;margin-top:-8px;"> 
                        <el-table-column label="序号" type="index" width="50" fixed align="center">
                            <el-table-column label="序号" type="index" width="50" fixed align="center">
                                <template slot="header"  >
                                    <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                        <el-tooltip content=" 清除条件" effect="light">
                                            <i class="iconfont icon-shanchu1"  ></i>
                                        </el-tooltip>
                                    </el-link>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column  v-for="(item,index ) in jobCol.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :sortable="item.sortable=='N'"
                            :min-width="item.width">
                            <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                                <template slot="header" slot-scope="scope">
                                    {{scope.row}}                     
                                    <el-input type="number" placeholder="数字框"  @keyup.enter.native="jobQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-if="item.edcss=='number'" size="mini" v-model="v_jobrow[item.key]" style="width:100%"> </el-input> 
                                    <el-input :disabled="item.edcss=='image'||item.key=='SEL'" v-else @keyup.enter.native="jobQry"  v-model="v_jobrow[item.key]" size="mini" placeholder="请输入" ></el-input> 
                                </template>
                                <template slot-scope="scope">
                                    <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                    <span v-else v-text="scope.row[item.key]"></span>
                                </template>
                            </el-table-column>
                        </el-table-column> 
                    </el-table>
                    <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
                        <div style="float: left;padding-left:4px;font-size:12px;">
                            <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                        </div>
                    </div>
                </template>
            </split-pane>
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                    <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
                </div>
                <div style=" margin:15px 3px; line-height:30px;display:flex">
                   <i class="iconfont icon-tishi1" style="font-size:36px;color:#389;line-height:30px;"></i> 
                   <div style="line-height:30px">{{prompt}}</div>
                </div>
                <div slot="footer">
                    <el-button type="primary" size="small"  @click="promptWin=false" style="margin-right:2px;">确定</el-button>
                </div>
            </el-dialog>
       
            <el-dialog v-dialogDrag :show-close="false" :visible.sync="editWin" width="400px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">操作类型</span>
                </div> 
                <el-radio-group v-model="radioVal">
                    <el-radio label="edit">编辑</el-radio>
                    <el-radio label="del">删除</el-radio>
                </el-radio-group>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px " >              
                    <span style="float:right">
                        <el-button type="info" @click="editWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                        <el-button @click="radioBtn" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 确定 </el-button>                 
                    </span> 
                </div>
            </el-dialog>
            <!--  明细编辑 -->
            <el-dialog v-dialogDrag :show-close="false" :visible.sync="jobWin" width="800px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">工艺明细</span>
                </div> 
                <Form :model="dtlRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in dtlCol" :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select  v-else-if="item.edcss==='select'" v-model="dtlRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input-number v-else-if="item.edcss==='number'"  v-model="dtlRow[item.key]" style="width:100%"></el-input-number>  
                            <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false"  v-model="dtlRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
 
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >              
                    <span style="float:right">
                        <el-button type="info" @click="jobExit" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                        <el-button @click="saveJob" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button>                 
                    </span> 
                </div>
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
        </template>
    </split-pane>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate,jsuuid} from '../../api/Select' 
export default {
    name:'prd_route',
    data () {
        return {
            dtlRow:{},
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                idseq:'idseq',
                parentid:'',
                label: 'label'
            },
      
            jobWin:false,
            jobData:[],
            v_jobno:'',
            loadWin:false,
            comboArr:[],
            promptWin:false,
            nodeLabel:'',
            loading:false,
            v_idseq:'',
            supFlag:'',
            treeid:'0',
            smpWin:false,
            supRow:{
                SUPNO:'' ,//供应商编码
                SUPNM:'', //供应商名称
                RMK:'', //备注
            },
            rowDtl:{},
            tyData:[],
            stfgSet:'ALL',
            radioVal:'edit',
            prompt:'',
            filterText: '',
            ruleValidate:{},
            v_code:'',
            selparam:'MATNO',
            txtparam:'',
            poRow:{},
 
            actitem:'one',
            v_all:'N',
     
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            jobCol:[],
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            allData:[],
  
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            editWin:false,
            treeCol: [],
            dataCount:0,
            rowSize:100,
            dtlCol:[],
            matCol:[],
 
            operArr:[],
            selparam2:'IDNO',
            txtparam2:'',
            loadingtree:false, 
            oper:'like',
            v_jobrow: {},
 
            v_matno:'',
            codeArr:[] ,
            v_row:{},
            v_stfg:'N' ,
        }
    },
    components: {
    },
    watch: {
      filterText(val) {
        this.$refs.eltree.filter(val);
      }
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 148) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
        scrollerHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
  
        this.comSelect()
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16558','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16558','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
 
            this.getJobList('') 
            this.getData()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        chkSel(val){
            this.jobData.forEach(item=>{
                item['SEL'] =val
            })
        },
        rowShow(){
            this.v_jobrow  ={}
            this.jobQry()
        } ,
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.jobData = this.allData.slice(_start,_end);
        },
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.jobData = this.allData          
            }else{
                this.jobData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        setType(row){
            if ( row['stfg'] =='Y'){
                this.codeArr.push(row['code'])
            }else{
                let index =this.codeArr.indexOf(row['code'])
                if (index >-1){
                    this.codeArr.splice(index,1)
                }
            }
        },
        //左边菜单
        getData() {  
            var vm=this;
 
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData' ,
                data: {p_table:'v_BS_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\' and ty=\'PRD\'' }
            }).then(function(res){                  
                vm.tyData =res.result   
                if(res.result.length > 0 ){
                    vm.$nextTick(() =>{
                        //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                }  
      
            })                              
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        handleNodeClick(data){
            this.nodeLabel=data.label         
            this.treeid =data.id
            this.v_idseq =data.idseq
            //console.log(this.v_idseq,'...')
            this.getDtlList(data.idseq)
            this.codeArr =[]
        },
        itemClick(val){
            this.actitem =val     
        },
        jobExit(){
           this.jobWin=false
           this.editWin =false
        },
        //树状工序保存
        saveJob(){
            let v_obj ={IDSEQ:this.v_idseq ,LSTSEQ:this.v_row['lstseq'],WKNO:this.dtlRow['wkno'],ISOUT:this.dtlRow['isout'],JOBDESC:(this.dtlRow['jobdesc']||'') ,
                TMUNIT:(this.dtlRow['tmunit']||''),BEFTIME:this.dtlRow['beftime'],PRDTIME:this.dtlRow['prdtime'],PCSCOST:this.dtlRow['pcscost'],HRCOST:this.dtlRow['hrcost'],
                USEDEV:(this.dtlRow['usedev']||''), RMK:(this.dtlRow['rmk']||''),SORTBY:this.dtlRow['pkid']}
  
            this.$axios({
                method: 'post',
                url:'xuper_auth/tableBodySave',
                data: {p_json:JSON.stringify(v_obj), p_table:'PRD_ROUTE',p_idseq:''},
            }).then(res=>{
                if (res.code=='200'){
                    this.getDtlList(this.v_idseq)
                    this.jobWin =false
                    this.editWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
        radioBtn(){
            if (this.radioVal =='del'){
                this.$confirm('删除层级时会把此层下面所有的子层全部删除，要继续吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:this.v_row['idseq'],p_cond:' and lstseq in (select lstseq from V_PRD_ROUTE start with code=\''+this.v_row['code']+'\' and idseq='+this.v_row['idseq']+' connect by prior code=parentno)',p_table:'PRD_ROUTE'},
                    }).then(res=>{ 
                        this.getDtlList(this.v_idseq)
                        this.editWin =false
                    })
                }).catch(()=>{})
            }else if (this.radioVal =='edit'){
                this.jobWin =true
                this.dtlRow =JSON.parse(JSON.stringify(this.v_row))
            }
        },
        jobLink(row){
            this.editWin =true
            this.v_row =JSON.parse(JSON.stringify(row))
        },
        selChg(code,val){
            if (val =='Y'){
                this.codeArr.push(code)
            }else{
                let index =this.codeArr.indexOf(code)
                if (index >-1){
                    this.codeArr.splice(index,1)
                }
            }
        },
        //工序清单 
        getJobList(cond){
            this.loading =true
            getTabColOrData(this.v_url,'v_bs_job','','','CORPID',this.v_corpid,'','',cond+' order by idno' ).then((res) => { 
                this.allData =res.result
                this.initPage() 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.loading =false
                }) 
            })
        },
  
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'16558',p_cond:' and lstseq in (1,2 )' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[(res.result[k].FLDNO).toLowerCase()] =res2.result
                        })
                    }
                }
            })  
        },
 
        // 明细 
        getDtlList(v_idseq ){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getMrpTreeData',
                data: {p_key:'idseq',p_value:v_idseq,p_table:'V_PRD_ROUTE',p_cond:'  order by sortby,adddttm'},
            }).then(res=>{ 
                this.dtlData =res.result
                this.codeArr =[]
                if (this.dtlData.length>0){
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs['reftree'].setCurrentRow(this.dtlData[0])
 
                    })
                }
            }) 
        },
        //将工序添加到工艺
        addJob(){
            this.$axios({   
                method: 'post',
                url: '/xuper_auth/getBaseData',
                data: {p_table:'v_BS_TYPE',p_key: 'parentno',p_value:this.treeid||0},
            }).then(res=>{
                if (res.result.length>0){
                    this.promptWin =true
                    this.prompt ='请选择产品类别下的子节点'
                    return
                }else{
                    let len =this.codeArr.length
                    if ( len >1){
                        this.promptWin =true
                        this.prompt ='请不要选择多条记录，仅能添加到一个节点下'
                    }
                    let v_parent  = this.codeArr[0] ||this.treeid
                    this.p_save_tech(v_parent)
                }
            })
        },
        p_save_tech(v_parent){
            let v_job =this.jobData.filter(item=>item['SEL']=='Y')
            if (v_job.length==0){
                this.promptWin =true
                this.prompt ='请选择工序'
                return 
            }
            if (v_job.length>10){
                this.promptWin =true
                this.prompt ='请选择工序条数小于10条'
                return 
            }
            this.loadWin =true
            const v_promise = v_job.map(async item=>{
                let v_obj ={IDSEQ:this.v_idseq,LSTSEQ:'', JOBNO:item['IDNO'],CORPID:this.v_corpid ,REFCODE :jsuuid(),REFPARENT:v_parent}
                return await this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave',
                    data: {p_json:JSON.stringify(v_obj), p_table:'PRD_ROUTE',p_idseq:'' },
                }).then(res=>{
                    item['SEL']='N'
                }) 
            })
            Promise.all(v_promise).then(()=>{
                this.getDtlList(this.v_idseq)
                this.loadWin =false                            
            })
        },
        getRowKey(row){
            return row.IDSEQ
        },
  
        jobQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_jobrow).forEach(item=>{
                if (this.v_jobrow[item] ){
                    this.jobCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_jobrow[item] 
                    }else{
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_jobrow[item]).toLowerCase().trim()+'%\''
                    }

                }
            }) 
            this.getJobList(v_cond)
        }, 
  
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16558','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.treeCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16558','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: (res.result[k].key).toLowerCase(),
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16558','lstseq','4206','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.jobCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .el-icon-arrow-right {
        color:#ff0000;
    }
    .el-table .el-table__expand-icon{
        .el-icon-arrow-right:before{
            content: '\e791';
        }
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
 
 
</style>